module.exports = __webpack_public_path__ + "img/whatsapp.c8be02b5.svg";